import { createContext, useContext, useState } from "react";
import { ColorPalette } from "@mirage/components/MapView/MapViewHelper";

export interface GaiaMapTheme {
    palette: ColorPalette;
}

interface GaiaMapThemeContextValue {
    theme: GaiaMapTheme;
    updateTheme: (newTheme: Partial<GaiaMapTheme>) => void;
}

const GaiaMapThemeContext = createContext<GaiaMapThemeContextValue>({
    theme: { palette: {} },
    updateTheme: (_: Partial<GaiaMapTheme>) => {
        console.warn("GaiaMapTheme.updateTheme was called before the provider was initialized");
    },
});

export const useGaiaMapTheme = () => useContext(GaiaMapThemeContext);

interface GaiaMapThemeProviderProps {
    initialTheme?: GaiaMapTheme;
    children: React.ReactNode;
}

export const GaiaMapThemeProvider: React.FC<GaiaMapThemeProviderProps> = ({ initialTheme = { palette: {} }, children }) => {
    const [theme, setTheme] = useState<GaiaMapTheme>(initialTheme);

    const updateTheme = (newTheme: Partial<GaiaMapTheme>) => {
        setTheme((current) => ({
            ...current,
            ...newTheme,
            palette: {
                ...current.palette,
                ...(newTheme.palette || {}),
            },
        }));
    };

    return <GaiaMapThemeContext.Provider value={{ theme, updateTheme }}>{children}</GaiaMapThemeContext.Provider>;
};
